var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.getTextModel)?[_c('el-switch',_vm._b({on:{"change":function (val) {
          _vm.item.change && _vm.item.change(val, _vm.item);
        }},model:{value:(_vm.form[_vm.item.bind]),callback:function ($$v) {_vm.$set(_vm.form, _vm.item.bind, $$v)},expression:"form[item.bind]"}},'el-switch',_vm.item,false))]:_c('div',[_vm._v("\n    "+_vm._s(_vm.form[_vm.item.bind])+"\n  ")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-633c016a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/SrAdd/components/form-item-switch.vue
// module id = 101
// module chunks = 0